import { Loader2 } from "lucide-react";
import type { ReactNode } from "react";

import { AppHeaderRail } from "@/components/common/AppHeaderRail";

export { ErrorBanner } from "@/components/common/ErrorBanner";

export function PageHeader({
  eyebrow,
  title,
  description,
  actions
}: {
  eyebrow?: string;
  title: string;
  description?: string;
  actions?: ReactNode;
}) {
  return (
    <AppHeaderRail
      eyebrow={eyebrow}
      title={<h1 className="truncate text-xl font-semibold">{title}</h1>}
      description={description}
      actions={actions}
    />
  );
}

export function LoadingState({ label = "Loading" }: { label?: string }) {
  return (
    <div className="flex min-h-72 items-center justify-center gap-2 text-sm text-muted-foreground">
      <Loader2 className="size-5 animate-spin text-primary" />
      {label}
    </div>
  );
}

export function EmptyState({ icon, title, description, action }: { icon?: ReactNode; title: string; description?: string; action?: ReactNode }) {
  return (
    <div className="flex min-h-56 flex-col items-center justify-center rounded-md border border-dashed bg-card px-4 py-8 text-center">
      {icon ? <div className="mb-3 flex size-10 items-center justify-center rounded-md bg-muted text-muted-foreground">{icon}</div> : null}
      <h2 className="text-sm font-semibold">{title}</h2>
      {description ? <p className="mt-1 max-w-md text-sm text-muted-foreground">{description}</p> : null}
      {action ? <div className="mt-4">{action}</div> : null}
    </div>
  );
}
